import React from 'react';
import { ServerComponentCaller } from '../../helpers';

const Ciclos = (props) => (
  <ServerComponentCaller url={'assets/data/pages/Ciclos.json'} />
);

export default Ciclos;
